import React, { Component } from "react";
import OrderCircuit from '../order-circuit/order-circuit.component';

class PrimaryOrderCircuit extends Component {
    constructor(props){
        super(props);
        this.state={

        }
    }
    render() {
        const {...props} = this.props;
        return (
            <div>
                  <OrderCircuit {...props} />
            </div>
        )
    }
}

export default PrimaryOrderCircuit;